import React, { useEffect, useContext, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { ContextGlobal } from "../../context";
import axios from "axios";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { config } from "../../config";

const useStyles = makeStyles((theme) => ({
  table: {
    width: "inherit",
  },
  table1: {
    minWidth: 650,
  },
  thbold: {
    fontWeight: "bold",
  },
  addPatientID: {
    margin: "10px 0px",
    boxShadow:
      "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
    color: "white",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "85%",
  },
}));

const HospitalData = (props) => {
  const { data } = useContext(ContextGlobal);
  const [hosData, setHosData] = useState([]);
  const [modalStat, setModalStat] = useState(false);
  const [rowIndex, setRowIndex] = useState(0);
  const classes = useStyles();

  const handleOpenClose = (i) => {
    setModalStat(!modalStat);
    setRowIndex(i);
  };

  useEffect(() => {
    if (props.hosData === undefined) {
      axios
        .post(`${config.url.BACKEND}/getHospitalInfo`, {
          pid: data.data.patientId ? data.data.patientId : [{ value: "" }],
        })
        .then((res) => {
          setHosData(res.data);
          // console.log(res.data);
        })
        .catch((error) => console.log(error));
    } else {
      setHosData(props.hosData);
    }
  }, []);

  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.thbold}>Hospital</TableCell>
              <TableCell className={classes.thbold} align="right">
                Disease
              </TableCell>
              <TableCell className={classes.thbold} align="right">
                Date
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(hosData).map((row) =>
              hosData[row].map((x, i) => (
                <TableRow
                  onClick={() => handleOpenClose(i)}
                  key={x.hospital + i}
                >
                  <TableCell component="th" scope="row">
                    {x.hospital}
                  </TableCell>
                  <TableCell align="right">{x.disease}</TableCell>
                  <TableCell align="right">{x.date}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {!props.docLogin ? (
        <Link to="profile/settings/#addPatientID">
          <Button
            className={classes.addPatientID}
            color="primary"
            variant="contained"
          >
            Add Patient ID
          </Button>
        </Link>
      ) : (
        ""
      )}
      <Modal
        className={classes.modal}
        open={modalStat}
        onClose={() => {
          handleOpenClose(rowIndex);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalStat}>
          <div className={classes.paper}>
            {hosData.length !== 0 ? (
              <>
                <h2>{hosData["hospitalData"][rowIndex].hospital}</h2>
                <TableContainer component={Paper}>
                  <Table className={classes.table1} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.thbold}>Date</TableCell>
                        <TableCell className={classes.thbold}>
                          {hosData["hospitalData"][rowIndex].date}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.thbold}>
                          Disease
                        </TableCell>
                        <TableCell className={classes.thbold}>
                          {hosData["hospitalData"][rowIndex].disease}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.thbold}>
                          Description
                        </TableCell>
                        <TableCell className={classes.thbold}>
                          {hosData["hospitalData"][rowIndex].description}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </TableContainer>
              </>
            ) : (
              ""
            )}
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default HospitalData;
